// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1owRi","content":"LayoutSettings_content__1cG9_"};